import { useStickyBottomBarContext } from "contexts/StickyBottomBarContext";
import type { StickyBottomBarTriggerProps } from "./StickyBottomBarTrigger.d";

const StickyBottomBarTrigger = ({ styles = {}, type, children }: StickyBottomBarTriggerProps) => {
  const { setFirstTriggerElement, setSecondTriggerElement } = useStickyBottomBarContext();
  const ref = { first: setFirstTriggerElement, second: setSecondTriggerElement }[type];

  return (
    <div ref={ref} style={styles}>
      {children}
    </div>
  );
};

export default StickyBottomBarTrigger;
